import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import StoreColumn from '../../../components/columns/store-column';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';
import { messages } from '../messages';

const Store = ({ fulfillmentId }) => {
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);
  const { store } = salesOrder ?? {};
  const { storeGuid } = store ?? {};

  return <StoreColumn storeGuid={storeGuid} />;
};

Store.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const store = {
  getMessageDescriptor: () => messages.store,
  name: <FormattedMessage {...messages.store} />,
  id: 'store',
  render: (data) => <Store fulfillmentId={data.id} />,
};
